function NRDockerIcon({ height = '24', width = '24', color = '#086DD7' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.173 10.0395C23.1126 9.9907 22.5479 9.56476 21.3581 9.56476C21.0605 9.56476 20.7465 9.59189 20.4203 9.64543C20.1904 8.06622 18.8873 7.29694 18.8266 7.26209L18.5069 7.07751L18.2961 7.38105C18.2804 7.40364 17.9102 7.94274 17.7284 8.71009C17.5151 9.61125 17.6445 10.4573 18.1024 11.1817C17.5495 11.4893 16.667 11.5695 16.4838 11.5719H1.80467C1.42168 11.5719 1.10879 11.8831 1.10729 12.2659C1.10148 13.6164 1.32405 14.9216 1.75069 16.04C2.25668 17.3664 3.00932 18.3429 3.98733 18.9424C5.08425 19.6145 6.87015 20 8.88681 20C9.83043 20 10.771 19.9148 11.6066 19.7534C12.9235 19.4996 14.1192 19.0653 15.16 18.4632C16.0677 17.938 16.8829 17.2701 17.5831 16.4784C18.7462 15.1623 19.4391 13.6923 19.9543 12.3915C20.0237 12.3943 20.0922 12.3956 20.1597 12.3956C21.4329 12.3956 22.2159 11.8866 22.6483 11.4593C23.1173 10.996 23.2842 10.5341 23.3016 10.4829L23.3928 10.2159L23.173 10.0395Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16517 11.1425H5.13236C5.2272 11.1425 5.3044 11.0655 5.3044 10.9702V9.21717C5.3044 9.12187 5.2272 9.04486 5.13236 9.04486H3.16517C3.07012 9.04486 2.99292 9.12187 2.99292 9.21717V10.9702C2.99292 11.0655 3.07012 11.1425 3.16517 11.1425Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.87604 11.1425H7.84279C7.9381 11.1425 8.01506 11.0655 8.01506 10.9702V9.21717C8.01506 9.12187 7.9381 9.04486 7.84279 9.04486H5.87604C5.78078 9.04486 5.7038 9.12187 5.7038 9.21717V10.9702C5.7038 11.0655 5.78078 11.1425 5.87604 11.1425Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62816 11.1425H10.5952C10.6902 11.1425 10.7674 11.0655 10.7674 10.9702V9.21717C10.7674 9.12187 10.6902 9.04486 10.5952 9.04486H8.62816C8.53314 9.04486 8.45618 9.12187 8.45618 9.21717V10.9702C8.45618 11.0655 8.53314 11.1425 8.62816 11.1425Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3481 11.1425H13.3151C13.4103 11.1425 13.4873 11.0655 13.4873 10.9702V9.21717C13.4873 9.12187 13.4103 9.04486 13.3151 9.04486H11.3481C11.2533 9.04486 11.1758 9.12187 11.1758 9.21717V10.9702C11.1758 11.0655 11.2533 11.1425 11.3481 11.1425Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.87604 8.62013H7.84279C7.9381 8.62013 8.01506 8.54312 8.01506 8.44803V6.69477C8.01506 6.59969 7.9381 6.52246 7.84279 6.52246H5.87604C5.78078 6.52246 5.7038 6.59969 5.7038 6.69477V8.44803C5.7038 8.54312 5.78078 8.62013 5.87604 8.62013Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62816 8.62013H10.5952C10.6902 8.62013 10.7674 8.54312 10.7674 8.44803V6.69477C10.7674 6.59969 10.6902 6.52246 10.5952 6.52246H8.62816C8.53314 6.52246 8.45618 6.59969 8.45618 6.69477V8.44803C8.45618 8.54312 8.53314 8.62013 8.62816 8.62013Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3481 8.62013H13.3151C13.4103 8.62013 13.4873 8.54312 13.4873 8.44803V6.69477C13.4873 6.59969 13.4103 6.52246 13.3151 6.52246H11.3481C11.2533 6.52246 11.1758 6.59969 11.1758 6.69477V8.44803C11.1758 8.54312 11.2533 8.62013 11.3481 8.62013Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3481 6.09767H13.3151C13.4103 6.09767 13.4873 6.02044 13.4873 5.92535V4.17231C13.4873 4.07701 13.4103 4 13.3151 4H11.3481C11.2533 4 11.1758 4.07701 11.1758 4.17231V5.92535C11.1758 6.02044 11.2533 6.09767 11.3481 6.09767Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0918 11.1425H16.0586C16.1539 11.1425 16.2308 11.0655 16.2308 10.9702V9.21717C16.2308 9.12187 16.1539 9.04486 16.0586 9.04486H14.0918C13.9966 9.04486 13.9196 9.12187 13.9196 9.21717V10.9702C13.9196 11.0655 13.9966 11.1425 14.0918 11.1425Z"
        fill={color}
      />
    </svg>
  );
}
export default NRDockerIcon;
